<template>
  <div class="MainStepsForm">
    <div v-show="tabIdx == 'tab1'" class="container">
      <a-alert
        message="中国知链为你自行上传的作品进行版权存证，不对您上传内容的真实性进行验证"
        type="warning"
        show-icon
      />

      <steps :stepIdx="2"></steps>

      <div class="commonWhiteBg">
        <div class="ant-popover-arrow"></div>
        <div class="commonTitle">版权登记</div>
        <div class="formWrap">
          <el-form ref="form" :model="form" :rules="rules" label-width="140px">
            <el-form-item label="选择存证文件" prop="evidenceFile">
              <el-select
                v-model="form.evidenceFile"
                multiple
                clearable
                placeholder="请选择已存证名称"
                @change="chooseFile"
              >
                <el-option
                  v-for="(item, index) in fileList"
                  :key="index"
                  :label="item.sourceName"
                  :value="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建登记名称" prop="subject">
              <el-input v-model="form.subject"></el-input>
            </el-form-item>
            <el-form-item
              label="权利权属"
              prop="ownership"
              class="ownershipRow"
            >
              <div class="ownershipWrap">
                <el-radio-group v-model="form.ownership">
                  <el-radio
                    v-for="(item, index) in ownershipOpt"
                    :key="index"
                    :label="index"
                  >
                    {{ item.label }}
                  </el-radio>
                </el-radio-group>
                <div class="tips">
                  <span class="red">*</span> 个人作品是指个人独立创作完成的作品
                </div>
              </div>
            </el-form-item>
            <el-form-item label="作者" class="personList" prop="author">
              <span v-for="(author, index) in form.author" :key="index">{{
                author.obligeeType == "1" ? author.userName : author.companyName
              }}</span>
              <el-button type="text" @click="isAuthorDialogVisible = true"
                >选择作者</el-button
              >
              <choose-person-dialog
                title="选择作者"
                v-if="isAuthorDialogVisible"
                v-model="form.author"
                :listOpt="obligees"
                :linkObj="{ label: '添加作者', path: '/Mine/RealName' }"
                @close="onSetAuthorDialogClose"
                @input="onChooseAuthor"
              ></choose-person-dialog>
            </el-form-item>
            <el-form-item class="personList"  label="著作权人" prop="right">
              <span v-for="(author, index) in form.right" :key="index"
                >{{
                  author.obligeeType == "1"
                    ? author.userName
                    : author.companyName
                }}&nbsp;</span
              >
              <el-button type="text" @click="isRightDialogVisible = true"
                >选择权利人</el-button
              >
              <choose-person-dialog
                title="选择权利人"
                v-if="isRightDialogVisible"
                v-model="form.right"
                :listOpt="obligees"
                :linkObj="{ label: '添加权利人', path: '/Mine/Obligee' }"
                @close="onSetRightDialogClose"
                @input="onChooseRight"
              ></choose-person-dialog>
            </el-form-item>
            <el-form-item label="作品创作类型" prop="creationType">
              <el-select
                v-model="form.creationType"
                clearable
                placeholder="请选择创作类型"
              >
                <el-option
                  v-for="(item,index) in constants.creationType"
                  :key="index"
                  :label="item.label"
                  :value="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="作品创作性质" prop="creationNature">
              <el-select
                v-model="form.creationNature"
                clearable
                placeholder="请选择作品创作性质"
              >
                <el-option
                  v-for="(item,index) in constants.creationNature"
                  :key="index"
                  :label="item.label"
                  :value="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创作完成时间" prop="finishTime">
              <el-date-picker
                v-model="form.finishTime"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
         
            <el-form-item label="创作完成地点" prop="location">
                 <china-area-data @change="selectArea"></china-area-data>
            </el-form-item>
            <el-form-item label="作品发表状态" prop="publishStatus">
              <el-select
                v-model="form.publishStatus"
                clearable
                placeholder="请选择作品发表状态"
              >
                <el-option
                  v-for="(item,index) in constants.publishStatus"
                  :key="index"
                  :label="item.label"
                  :value="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="权益拥有情况" prop="rightHave">
              <multiple-select
                v-model="form.rightHave"
                :listOpt="constants.right"
                :worksType="form.worksType"
              ></multiple-select>
            </el-form-item>
            <el-form-item label="创作意图" prop="yitu">
              <el-input
                v-model="form.yitu"
                :rows="3"
                placeholder="请输入创作意图"
                type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item label="作品独创性" prop="name">
              <el-input
                v-model="form.duchuang"
                :rows="3"
                placeholder="请输入作品独创性"
                type="textarea"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="支付方式"
              prop="paymode"
              class="choosePayStyle"
            >
              <el-radio-group v-model="form.paymode">
                <el-radio label="vip">
                  <span class="onlyText"
                    >中国知链会员权益支付（当前存证次数可用{{vipInfo?vipInfo.registerCount:0}}次）</span
                  >
                </el-radio>
                <el-radio label="alipay">
                  <i class="iconfont aliPayColor"> &#xe634; </i>
                  <span>支付宝支付</span></el-radio
                >
                <!-- <el-radio label="wechat">
                  <i class="iconfont weChatColor"> &#xe633; </i>
                  <span>微信支付</span></el-radio
                > -->
              </el-radio-group>
              <router-link class="buyVip" :to="{ path: '/Vip' }"
                >购买会员</router-link
              >
            </el-form-item>
            <el-form-item label="支付金额" v-if="form.paymode != 'vip'">
              <div><em class="bigPrice"> {{form.orderAmount}} </em> 元</div>
            </el-form-item>
            <el-form-item class="submitRow">
              <el-button type="primary" @click="onSubmit"
                >提交版权登记</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <result-view v-if="tabIdx == 'tab2'" :orderInfo="form" @set-tab-idx="setTabIdx">
    </result-view>
  </div>
</template>

<script>
import {
  queryExistOrderItems
} from "@/api/EvidenceService";
import { queryObligeeList } from "@/api/ObligeeService";
import Steps from "../../components/Steps";
import multipleSelect from "../../../../components/form/multipleSelect";
import choosePersonDialog from "../../../../components/form/choosePersonDialog";
import resultView from "./components/resultView";
import ChinaAreaData from '@/components/common/ChinaAreaData'
import { mapGetters } from "vuex";
import { mixinsScrollErrorPosition } from '../../../../mixins';
import constants from "@/utils/constants";
export default {
  name: "RegisterInputForm",
   mixins: [mixinsScrollErrorPosition],
  components: { Steps, multipleSelect, choosePersonDialog, resultView,ChinaAreaData },
  data() {
    return {
      constants,
      tabIdx: "tab1",
      fileList: [],
      obligees: [],
      creationTypeOpt: [
        {
          value: "1",
          label: "美术作品登记",
        },
        {
          value: "2",
          label: "文学作品登记",
        },
        {
          value: "3",
          label: "音乐作品登记",
        },
        {
          value: "4",
          label: "口述作品登记",
        },
        {
          value: "5",
          label: "视频作品登记",
        },
        {
          value: "6",
          label: "其它作品登记",
        },
      ],
      creationNatureOpt: [
        {
          value: "1",
          label: "原创",
        },
        {
          value: "2",
          label: "改编",
        },
        {
          value: "3",
          label: "翻译",
        },
        {
          value: "4",
          label: "汇编",
        },
        {
          value: "5",
          label: "注释",
        },
      ],
      publishStatusOpt: [
        {
          value: "1",
          label: "未发表",
        },
        {
          value: "2",
          label: "已发表",
        },
      ],
      adressOpt: [
        {
          value: "1",
          label: "上海",
        },
        {
          value: "2",
          label: "北京",
        },
      ],
      ownership: [
        {
          value: "2",
          label: "已发表",
        },
      ],
      ownershipOpt: [
        {
          value: "1",
          label: "个人作品",
        },
        {
          value: "2",
          label: "法人作品",
        },
        {
          value: "3",
          label: "合作作品",
        },
        {
          value: "4",
          label: "职务作品",
        },
        {
          value: "5",
          label: "委托作品",
        },
      ],
      listOpt: [
        {
          value: "1",
          label: "发表权",
        },
        {
          value: "2",
          label: "署名权",
        },
        {
          value: "3",
          label: "修改权",
        },
        {
          value: "4",
          label: "复制权",
        },
        {
          value: "5",
          label: "发行权",
        },
        {
          value: "6",
          label: "出租权",
        },
        {
          value: "7",
          label: "展览权",
        },
        {
          value: "8",
          label: "表演权",
        },
        {
          value: "9",
          label: "放映权",
        },
        {
          value: "10",
          label: "广播权",
        },
        {
          value: "11",
          label: "摄制权",
        },
        {
          value: "12",
          label: "改编权",
        },
        {
          value: "13",
          label: "翻译权",
        },
        {
          value: "14",
          label: "汇编权",
        },
        {
          value: "15",
          label: "其他",
        },
      ],
      form: {
        files:[],
        evidenceFile: [],
        creationType: "",
        creationNature: "",
        publishStatus: "",
        province: '',
        ownership: "",
        name: "",
        finishTime: "",
        yitu: "",
        duchuang: "",
        paymode: 'wechat',
        orderAmount:0,
        rightHave: [],
        author: [],
        right: [],
      },
      rules: {
        subject: [
          { required: true, message: '请输入登记名称', trigger: 'blur' },
          { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
        ],
        province:[{ required: true, validator: this.valiCity, trigger: 'blur' }]
      },
      isAuthorDialogVisible: false,
      isRightDialogVisible: false,
    };
  },
  computed: {
    ...mapGetters(["mid", "userInfo", "evidencePaymentPrice","vipInfo"]),
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      queryExistOrderItems().then(({ data }) => {
        this.fileList = data;
      });
      queryObligeeList(1, 100).then(({ data }) => {
        this.obligees = data.list;
      });
    },
    calAmount() {
      let amount = 0;
      let registerConfig = this.evidencePaymentPrice.register;
        amount = registerConfig.amount * 1;

      this.form.orderAmount = amount;
    },
    async onSubmit () {
      console.log("onSubmit..")
      // 检查VIP支付次数
      if (this.form.paymode === 'vip') {
        const availableCount = this.vipInfo ? this.vipInfo.registerCount : 0;
        if (availableCount <= 0) {
          this.$message.warning('当前会员权益支付次数为0');
          return;
        }
      }
      try {
        const formBaseResult = await this.$refs['form'].validate()
      } catch (error) {
        // 有错误,定位到错误
        // eslint-disable-next-line
        console.error(error)
        this.mixinsScrollView()
        return
      }
      this.setTabIdx('tab2')
     },
    setTabIdx(tabIdx) {
      this.tabIdx = tabIdx;
    },
    onSetAuthorDialogClose() {
      this.isAuthorDialogVisible = false;
    },
    onSetRightDialogClose() {
      this.isRightDialogVisible = false;
    },
    onChooseAuthor(users) {
      this.form.author = users;
    },
    onChooseRight(users) {
      this.form.right = users;
    },
    valiCity(rule, value, callback){ 
					if (!this.form.province) {
					  callback(new Error('请选择省份'));
					  return;
					}
					if (!this.form.city) {
					  callback(new Error('请选择城市'));
					  return;
					}
					if (!this.form.area) {
					  callback(new Error('请选择区县'));
					  return;
					}
					callback();
			},
    selectArea(data){
      	this.form.province = data.selectData.province.name;
				this.form.city = data.selectData.city.name;
        this.form.area = data.selectData.area.name;
    },
    chooseFile(){
      let files=[];
      for (let i = 0; i < this.form.evidenceFile.length; i++) {
        const element = this.form.evidenceFile[i];
        files.push(this.fileList[element*1]);
      }
      this.form.files=files;
      this.calAmount();
    }
  },
};
</script>

<style lang='scss' scoped>
@import "../../../../assets/css/inputForm.scss";
.commonWhiteBg {
  /deep/ .ant-popover-arrow {
    left: 30%;
  }
}
.ownershipRow {
  margin-bottom: 0;
}
.ownershipWrap {
  position: relative;
  padding-top: 40px;
  /deep/ .el-radio-group {
    position: absolute;
    width: 200%;
    left: 0;
    top: 11px;
  }
  .tips {
    .red {
      color: #ff4d4f;
      vertical-align: middle;
    }
  }
}
</style>
